import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsMultiNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      viewBox="0 0 48 48"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M27 21.584L23.15 28H20v3h4.85L27 27.416l6 10L36.85 31H40v-3h-4.85L33 31.584l-6-10z"
        fill=""
      />
      <path
        d="M32.507 8.493C29.447 3.404 23.871 0 17.5 0 7.835 0 0 7.835 0 17.5c0 6.37 3.404 11.946 8.493 15.007a17.588 17.588 0 006 6C17.553 43.596 23.129 47 29.5 47 39.165 47 47 39.165 47 29.5c0-6.37-3.404-11.946-8.493-15.007a17.588 17.588 0 00-6-6zM17.5 3a14.44 14.44 0 019.2 3.292A17.6 17.6 0 0023.5 6C13.835 6 6 13.835 6 23.5c0 1.093.1 2.163.292 3.2A14.44 14.44 0 013 17.5C3 9.492 9.492 3 17.5 3zM12 29.5c0 1.093.1 2.163.292 3.2A14.44 14.44 0 019 23.5C9 15.492 15.492 9 23.5 9a14.44 14.44 0 019.2 3.292A17.6 17.6 0 0029.5 12C19.835 12 12 19.835 12 29.5zM29.5 15C37.508 15 44 21.492 44 29.5S37.508 44 29.5 44 15 37.508 15 29.5 21.492 15 29.5 15z"
        fill=""
      />
    </svg>
  )
);
SvgSportsMultiNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsMultiNormalLarge;
